import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
export const usePasswordRecoveryValidationSchema = () => {
    const { t } = useTranslation();
    return Yup.object({
        password: Yup.string()
            .required(t('common.form.validation.password.required'))
            .min(6, t('common.form.validation.password.short'))
            .max(256, t('common.form.validation.password.long'))
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ -/:-@\\[-`{-~]).{6,64}$/, t('common.form.validation.password.letters')),
        newPassword: Yup.string()
            .required(t('common.form.validation.password.required'))
            .min(6, t('common.form.validation.password.short'))
            .max(256, t('common.form.validation.password.long'))
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ -/:-@\\[-`{-~]).{6,64}$/, t('common.form.validation.password.letters'))
            .label('Password Confirm')
            .required()
            .oneOf([Yup.ref('password')], 'Passwords do not match')
    });
};
